import {
  Bone,
  HeaderSkeleton,
  Line,
  PanelSkeleton,
  placeholderKeys,
  SkeletonRegion,
  TableSkeleton,
} from '@ems/ui/patterns/skeleton-blocks'

const TILE_KEYS = placeholderKeys('tile', 4)

function TilesSkeleton() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {TILE_KEYS.map((key) => (
        <PanelSkeleton key={key} title="w-24" className="gap-2 md:p-4">
          <Line size="xl" width="w-36" />
          <Line width="w-28" />
        </PanelSkeleton>
      ))}
    </div>
  )
}

function FiltersSkeleton() {
  return (
    <div className="flex flex-wrap gap-2">
      <Bone className="h-9 min-w-64 flex-1" />
      <Bone className="h-9 w-44" />
    </div>
  )
}

export function InvoicesSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-28" description="w-72" actions={['h-9 w-32']} />
      <TilesSkeleton />
      <FiltersSkeleton />
      <TableSkeleton
        card={{ title: 'w-36', description: null }}
        columns={[
          { cell: 'mono', widths: ['w-28', 'w-32'], primary: true },
          { cell: 'text', widths: ['w-40', 'w-32', 'w-48'] },
          { cell: 'badge', widths: ['w-20', 'w-16'] },
          { cell: 'text', widths: ['w-20', 'w-24'] },
          { cell: 'text', widths: ['w-24', 'w-20'], align: 'end' },
          { cell: 'text', widths: ['w-20', 'w-24'], align: 'end', header: 'w-24' },
        ]}
      />
    </SkeletonRegion>
  )
}

export function PaymentsSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-28" description="w-72" actions={['h-9 w-36']} />
      <FiltersSkeleton />
      <TableSkeleton
        card={{ title: 'w-32', description: null }}
        columns={[
          { cell: 'mono', widths: ['w-28', 'w-32'], primary: true },
          { cell: 'text', widths: ['w-32', 'w-40'] },
          { cell: 'text', widths: ['w-24', 'w-20'] },
          { cell: 'badge', widths: ['w-20', 'w-16'] },
          { cell: 'text', widths: ['w-24', 'w-20'], align: 'end' },
          { cell: 'text', widths: ['w-20', 'w-24'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}

export function CreditNotesSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-32" description="w-80" />
      <TableSkeleton
        card={{ title: 'w-32', description: null }}
        columns={[
          { cell: 'mono', widths: ['w-24', 'w-28'], primary: true },
          { cell: 'mono', widths: ['w-28', 'w-32'] },
          { cell: 'text', widths: ['w-48', 'w-40'] },
          { cell: 'badge', widths: ['w-16', 'w-20'] },
          { cell: 'text', widths: ['w-24', 'w-20'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}

/** An invoice or a payment: a header, a row of figures, two panels, a table. */
export function DocumentSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-56" description="w-64" actions={['h-9 w-32', 'h-9 w-32']} />
      <TilesSkeleton />
      <div className="grid gap-6 md:grid-cols-2">
        <PanelSkeleton title="w-24">
          <Line width="w-48" />
          <Line width="w-56" />
          <Line width="w-40" />
        </PanelSkeleton>
        <PanelSkeleton title="w-24">
          <Line width="w-44" />
          <Line width="w-52" />
          <Line width="w-36" />
        </PanelSkeleton>
      </div>
      <TableSkeleton
        card={{ title: 'w-28', description: null }}
        rows={3}
        columns={[
          { cell: 'text', widths: ['w-48', 'w-40'], primary: true },
          { cell: 'text', widths: ['w-10', 'w-8'], align: 'end' },
          { cell: 'text', widths: ['w-24', 'w-20'], align: 'end' },
          { cell: 'text', widths: ['w-24', 'w-28'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}

/** The payment methods: a header and one short table. */
export function PaymentMethodsSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-40" description="w-96" />
      <TableSkeleton
        card={{ title: 'w-32', description: null }}
        columns={[
          { cell: 'text', widths: ['w-32', 'w-28'], primary: true },
          { cell: 'badge', widths: ['w-16', 'w-16'] },
          { cell: 'text', widths: ['w-24', 'w-28'] },
          { cell: 'text', widths: ['w-10', 'w-10'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}
